import images from "../../../helper/images";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faXmarkCircle } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import { getAIRecommendationsAPI, getSearchRecommendationsAPI } from "../../../service/ai-model.service";
import { useAppContext } from "../../../context/app.context";
import CustomLoader from "../../common/CustomLoader";
import { Link, NavLink, useNavigate, useNavigation } from "react-router-dom";
import constant, { RecommendationType } from "../../../helper/constant";

const AIRecommendation = () => {
    const [filterList, setFilterList] = useState([]);
    const [recommendationList, setRecommendationList] = useState([]);
    const { updateLoader, isLoading } = useAppContext();
    const navigate = useNavigate()

    useEffect(() => {
        updateLoader(true);
        getAIRecommendationsAPI()
            .then((res) => {
                if (res && res.length) {
                    const filters = [...new Set(res.map(item => item.category))];
                    setFilterList(filters);
                    setRecommendationList(res);
                }
            }).finally(() => updateLoader(false));
    }, []);

    const autoCompleteItemSelect = (item) => {
        console.log("Selected Item: ", item);
    }

    const renderAskMeAnything = () => {
        return (
            <form className="form-inline search-bar">
                <GroupedAutocomplete onItemSelect={autoCompleteItemSelect} />
            </form>
        )
    }

    const renderFilterSection = () => {
        if (filterList && filterList.length) {
            return filterList.map((item, index) => (
                <div className="d-flex align-items-center mb-3 gap-4" key={index}>
                    <button className="btn btn-outline-secondary mr-2 bg-white aibtns d-flex align-items-center">
                        <img src={images.filterAvatarAI} width="30" height="30" />{item}</button>
                </div>
            ))
        }
    }

    const onApproveRecommendation = (item) => {
        // API Call to Approve Recommendation
    }

    const onEditRecommendation = (item) => {
        // Open Modal to Edit Recommendation
        navigate(`${constant.PAGES.HOME.AI_WORKFLOW}/${item.workflowId}`);
    }

    const onSkipRecommendation = (item) => {
        // API Call to Skip Recommendation
    }
    const onCloseRecommendation = (item) => {
        // API Call to Close Recommendation
        const list = recommendationList.filter(rec => rec.id !== item.id);
        setRecommendationList(list);
    }

    const renderRecommendationCards = () => {
        if (recommendationList && recommendationList.length) {
            return recommendationList.map((item, index) => (
                <div className={`recommendation-card recommendation-card-${item.priority}`} key={index}>
                    <div className="d-flex justify-content-between mb-4">
                        <h6 className="d-flex gap-1 align-items-center">
                            <img src={images.filterAvatarAI} width="30" height="30" />
                            <p className="m-0 p-0">{item.id || 'AVTAR AI'}</p>
                        </h6>
                        <button className="btn btn-sm p-0 crossbtnss" onClick={() => onCloseRecommendation(item)}><FontAwesomeIcon icon={faXmark} color="text-gray" /></button>
                    </div >
                    <p dangerouslySetInnerHTML={{ __html: item.description }}></p>
                    <div>
                        {/* {item.status === RecommendationType.EVENT && <Link className="btn btn-approve btn-sm mr-2" to={`${constant.PAGES.HOME.AI_WORKFLOW}/${item.workflowId}`}>Approve</Link>}
                        {item.status === RecommendationType.EVENT && <Link className="btn btn-edit btn-sm mr-2" to={`${constant.PAGES.HOME.AI_WORKFLOW}/${item.workflowId}`} >Edit</Link>} */}
                        <NavLink className="btn btn-skip btn-sm" to={item.url} target="_blank" >View</NavLink>
                    </div>
                </div >
            ))
        } else {
            return <div className="text-center text-muted">No Recommendations Found</div>
        }
    }

    const render = () => {
        return (
            <>
                {isLoading && <CustomLoader full />}
                <div className="container-fluid mt-5 pl-5 pb-5">
                    <div className="row">
                        <div className="col-lg-10">
                            <div className="mb-5">
                                {renderAskMeAnything()}
                            </div>
                            {renderFilterSection()}
                            <h4 className="text-muted mb-4 textblue font-weight-normal pt-2">Recent Recommendations</h4>
                            {renderRecommendationCards()}
                        </div>
                        <RightSideBar />
                    </div>
                </div>
            </>
        );
    }

    return render();
};

export default AIRecommendation;

const RightSideBar = () => {

    const render = () => {
        return (<div className="col-lg-2">
            <div className="right-sidebar">
                <div className="section">
                    <h4 className="textblue font-weight-normal">Signals & Contexts</h4>
                </div>

                <div className="section border-bottom">
                    <h6 className="textblue">Meetings</h6>
                    <div className="mb-2">
                        <div className="textblue">10:45 am</div>
                        <p className="mb-2"><strong>John Mathew</strong><br />Operational Head<br />ABC Mortgage Company</p>
                    </div>
                    <div className="">
                        <div className="textblue">10:45 am</div>
                        <p className="mb-2"><strong>John Mathew</strong><br />Operational Head<br />ABC Mortgage Company</p>
                    </div>
                </div>

                <div className="section border-bottom">
                    <h6 className="textblue">Health & Wellness</h6>
                    <div className="textblue">3:30 pm</div>
                    <p className="mb-2"><span className="textblue">Doctor Appointment</span><br /><strong>Dr. John
                        Mathew</strong><br />Holly Cross Centre</p>
                    <div className="textblue">5:00 pm</div>
                    <p><span className="textblue">Yoga Session</span><br />Fitness Centre</p>
                </div>

                <div className="section">
                    <h6 className="textblue">Trending</h6>
                    <p><strong>AI in Education</strong><br /><small>by John Mathew</small></p>
                </div>
            </div>
        </div>
        )
    }
    return render()
}

const GroupedAutocomplete = ({ onItemSelect }) => {
    const [data, setData] = useState([]);
    const [query, setQuery] = useState("");
    const [showList, setShowList] = useState(false);

    useEffect(() => {
        if (query) {
            getSearchRecommendationsAPI(query)
                .then((res) => setData(res));
        }
    }, [query])

    // Filter data based on query
    const filtered = data.filter((item) =>
        item.label.toLowerCase().includes(query.toLowerCase())
    );

    // Group filtered results
    const grouped = filtered.reduce((acc, item) => {
        if (!acc[item.group]) acc[item.group] = [];
        acc[item.group].push(item);
        return acc;
    }, {});

    return (
        <div className="postion-relative w-100 mx-auto mt-10">
            <div className="d-flex justify-content-between align-items-center">
                <input
                    type="text"
                    value={query}
                    onChange={(e) => {
                        setQuery(e.target.value);
                        setShowList(true);
                    }}
                    onFocus={() => setShowList(true)}
                    onBlur={() => setTimeout(() => setShowList(false), 150)}
                    placeholder="Ask me anything..."
                    className="w-100 px-3 py-1 rounded-0 border shadow-sm focus:outline-none focus:ring focus:ring-blue-300"
                />
                {query && <Link className="recommendtion-clear-btn" onClick={() => setQuery('')}><FontAwesomeIcon icon={faXmark} /></Link>}
            </div>
            {showList && query && (
                <div className="absolute z-10 w-full bg-white border mt-1 rounded-lg shadow-lg max-h-60 overflow-y-auto">
                    {Object.keys(grouped).length === 0 ? (
                        <div className="p-3 text-grey text-sm">No results</div>
                    ) : (
                        Object.keys(grouped).map((group) => (
                            <div key={group}>
                                <div className="px-3 py-1 text-grey bg-light-grey text-sm">
                                    {group}
                                </div>
                                {grouped[group].map((item) => (
                                    <div
                                        key={item.label}
                                        onClick={() => {
                                            onItemSelect && onItemSelect(item);
                                            setQuery(item.label);
                                            setShowList(false);
                                        }}
                                        className="px-3 py-2 auto-complete cursor-pointer"
                                    >
                                        {item.label}
                                    </div>
                                ))}
                            </div>
                        ))
                    )}
                </div>
            )}
        </div>
    );
}
